@if (profile) {
  <article id="{{ renderMode }}">
    <section id="profile-pic" [ngClass]="noProfilePic ? 'no-profile-pic' : ''" class="{{namespace}}">
      <div
        class="blur-profile {{ profile.type }}"
        [style.background-image]="noProfilePic ? '' : 'url(' + profile.profilePicBlurred + ')'"
      ></div>
      <div class="profile-pic-container">
        <img src="{{ profile.profilePic }}" (load)="imageLoaded()" />
        @if (noProfilePic) {
          <div class="preview-initials">
            {{ profile.name | GetInitials }}
          </div>
        }
      </div>
    </section>
    <section id="profile-details">
      <h2 class="heading-underline">
        {{ profile.name }}
        <div>
          <!-- TODO: AJ fix this with CSS (apparently) -->
          @if (profile.jobTitle) {
            <span>{{ profile.jobTitle }}, </span>
          }
          @if (profile.companyName) {
            <span>{{ profile.companyName }}</span>
          }
        </div>
      </h2>
      <ul class="contact-details">
        <li class="id-details">
          <mat-icon class="material-icons-outlined">badge</mat-icon>
          ID: {{ profile.id }}
        </li>
        @for (detail of profile.contactPhones; track detail) {
          <li class="phone-details" @transitionNewLiInOut>
            <a href="tel:{{ detail.formattedPhone }}" [matTooltip]="'Call ' + detail.displayTitle + ' Number'" matTooltipShowDelay="500">
              <mat-icon>
                @if (detail.fieldName === 'BusinessPhone' || detail.fieldName === 'HomePhone') {
                  phone
                }
                @if (detail.fieldName === 'MobilePhone') {
                  phone_iphone
                }
              </mat-icon>
            </a>
            {{ detail.displayTitle }}:
            <a href="tel:{{ detail.formattedPhone }}" [matTooltip]="'Call ' + detail.displayTitle + ' Number'" matTooltipShowDelay="500">{{
              detail.formattedPhone
            }}</a>
          </li>
        }
        @for (detail of profile.contactEmails; track detail) {
          <li @transitionNewLiInOut>
            <a href="mailto:{{ detail.emailAddress }}" [matTooltip]="'Email ' + detail.emailAddress" matTooltipShowDelay="500">
              <mat-icon>
                @if (detail.isBusiness) {
                  work
                }
                @if (detail.isPersonal) {
                  account_circle
                }
                @if (!detail.isBusiness && !detail.isPersonal) {
                  email
                }
              </mat-icon>
            </a>
            @if (detail.isBusiness) {
              Business Email:
            }
            @if (detail.isPersonal) {
              Personal Email:
            }
            @if (!detail.isBusiness && !detail.isPersonal) {
              Email:
            }
            <a href="mailto:{{ detail.emailAddress }}" [matTooltip]="'Email ' + detail.emailAddress" matTooltipShowDelay="500">{{
              detail.emailAddress
            }}</a>
          </li>
        }
      </ul>
    </section>
  </article>
}
